/* eslint-disable prettier/prettier */
import axios from 'axios'
import env from '../stores/modules/envdetect'
import store from '../stores/store';

// Default referring to a laracast about cors
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const apiClient = axios.create();

export default {
    useCheckService() {
        // let url = "https://bitve190.vis-extranet.de:31443/VierGewinntMiddleTier/rest/callVierGewinntMiddleTierCheckService";
        // let url = "https://tarifrechner-i.vis-extranet.de/VierGewinntMiddleTier/rest/callVierGewinntMiddleTierCheckService";
        let url = env + "VierGewinntMiddleTier/rest/callVierGewinntMiddleTierCheckService";
        let viergewinnt = store.getters['work/getExportDataForCheckService'];
        return apiClient.post(
            url,
            viergewinnt,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },
    useSendService() {
        // let url = "https://bitve190.vis-extranet.de:31443/VierGewinntMiddleTier/rest/callVierGewinntMiddleTierSendService";
        // let url = "https://tarifrechner-i.vis-extranet.de/VierGewinntMiddleTier/rest/callVierGewinntMiddleTierSendService";
        // https://bitve191.vis-extranet.de/DigitalSchutzMiddleTier/rest/callDigitalSchutzMiddleTierInitService
        let url = env + "VierGewinntMiddleTier/rest/callVierGewinntMiddleTierSendService";
        let viergewinnt = store.getters['work/getExportDataForSendService'];
        return apiClient.post(
            url,
            viergewinnt,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}
